//- ANGULAR
import { Component } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
//- TECH

//- BACKEND
import {
  CardReceiptDto,
  GetCardReceiptsOfTodayQuery,
  ICardReceiptDto,
  ICardReceiptPostDto,
  CardReceiptPostDto,
  FileParameter,
  CardReceiptClient,
  GetCardFilterStructureQuery,
} from '@tech/api-clients/receipts';

//- OWN
import { PermanentTableComponent } from '@features/receipts/components/permanent-table/permanent-table.component';
import {
  IFilters,
  PermanentTablePaginatedComponent,
} from '@features/receipts/components/permanent-table-paginated/permanent-table-paginated.component';
import { PrettyConsole } from '@app/shared/utils';
import { FileProcessorService } from '@app/shared/services/wasm/file-processor/file-processor.service';
import { NotificationService } from '@shared/services/notification/notification.service';
import { NotificationhubService } from '@app/shared/services/notificationhub/notificationhub.service';
import { ReceiptComponent } from '../../components/receipt/receipt.component';

//~ BEGIN

interface ReceiptDisplay extends ICardReceiptPostDto {
  file: string;
  ok: boolean;
  [key: string]: string | number | boolean | Date | undefined;
}

@Component({
  selector: 'app-receipt-card',
  standalone: true,
  imports: [ReceiptComponent],
  templateUrl: './receipt-card.component.html',
  styleUrl: './receipt-card.component.scss',
})
export class ReceiptCardComponent extends ReceiptComponent {
  // displaying
  stagedReceipts: ReceiptDisplay[] = [];
  available_f: IFilters[] = [];
  displayedColumns: string[] = [
    'file',
    'err_line',
    ...Object.keys(CardReceiptPostDto.prototype.toJSON()).map((c) =>
      c.toLowerCase()
    ),
  ];

  // HACK: WASM
  validation_s = {
    fecha: {
      type: 'regex',
      pattern: '\\d{2}/\\d{2}/\\d{4}|\\d{4}/\\d{2}/\\d{2}',
    },
    hora: {
      type: 'regex',
      pattern: '^([01]\\d|2[0-3]|\\d):[0-5]\\d(?<secs>:[0-5]\\d)?$',
    },
  };

  _wasm_split_pattern: string = ';';

  constructor(
    dialog: MatDialog,
    fileProcessor: FileProcessorService,
    notify: NotificationService,
    hub: NotificationhubService,
    private client: CardReceiptClient
  ) {
    super(dialog, fileProcessor, notify, hub);

    this.sse_name = 'CardReceipt';
    this.upload_handler = this.client_proc.bind(this);
    this.callme = this.callme_c.bind(this);
    this.get_paginated_data = this.get_paginated_data_c.bind(this);
    this.client
      .getFilterStructure(GetCardFilterStructureQuery.fromJS({}))
      .subscribe({
        next: (d) => {
          var parsed = JSON.parse(d);
          this.available_f = parsed;
        },
        error: (e) => {
          PrettyConsole.ERROR(
            `Something failed while getting filter structure ${e}`
          );
        },
      });
  }

  client_proc = (file_params: FileParameter[]) => {
    return this.client.uploadCardFiles(file_params);
  };

  lookup_permanent_c = (_: Event) => {
    const loading$: BehaviorSubject<boolean> = new BehaviorSubject(true);
    const ds = new PermanentCardReceipts();
    this.client
      .getCardReceiptsOfToday(GetCardReceiptsOfTodayQuery.fromJS({}))
      .subscribe({
        next: (receipts) => {
          ds.setData(receipts);
          loading$.next(false);
        },
        error: (err) => {
          PrettyConsole.ERROR(
            `getCardReceiptOfToday got error on subscribe ${err}`
          );
          loading$.next(false);
        },
      });

    this.dialog.open(PermanentTableComponent<PermanentCardReceipts>, {
      width: '85vw',
      height: '80vh',
      data: {
        title: 'Receipts of last remittance',
        receipts: ds,
        display: Object.keys(CardReceiptDto.prototype.toJSON()),
        loading$,
        callback: this.callme,
      },
    });
  };

  callme_c = () => {
    this.dialog.closeAll();
    const data_source = new PermanentCardReceipts();
    this.dialog.open(PermanentTablePaginatedComponent<ICardReceiptDto>, {
      width: '100vw',
      maxWidth: '98vw',
      height: '95vh',
      data: {
        receipts: data_source,
        display: Object.keys(CardReceiptDto.prototype.toJSON()).filter(
          (d) => d !== 'id'
        ),
        callback: this.get_paginated_data,
        filters: this.available_f,
      },
    });
  };

  get_paginated_data_c = (
    page_index: number,
    page_size: number,
    filters: IFilters[]
  ) => {
    let data = new BehaviorSubject<ICardReceiptDto[]>([]);
    let count = new BehaviorSubject<number>(0);

    let filter_values: Record<string, any> = {};
    filters.forEach((f) => {
      filter_values[f.id] = f.value === null ? undefined : f.value;
    });

    this.client
      .getAllCardReceipts(page_index, page_size, JSON.stringify(filter_values))
      .subscribe({
        error: (_) => {
          PrettyConsole.ERROR(
            `Error while getting the paypal receipts of all time, page: ${page_index}, size: ${page_size}`
          );
        },
        next: (d) => {
          if (d.count) count.next(d.count);
          if (d.receipts) data.next(d.receipts);
        },
      });
    return { count: count.asObservable(), data: data.asObservable() };
  };
}

export class PermanentCardReceipts extends DataSource<ICardReceiptDto> {
  private data = new BehaviorSubject<ICardReceiptDto[]>([]);

  connect(): Observable<ICardReceiptDto[]> {
    return this.data.asObservable();
  }

  addRow(row: ICardReceiptDto) {
    const current = this.data.getValue();
    this.data.next([...current, row]);
  }

  setData(rows: CardReceiptDto[]) {
    const data = rows.map((r) => r.toJSON());
    this.data.next(data);
  }

  disconnect(): void {}
}

// END
